module.exports = __webpack_public_path__ + "static/me-572d3eec479beef76b0fb6b86f1eb7f8.jpg";